import {
    VOUCHER_LIST_REQUEST,
    VOUCHER_LIST_SUCCESS,
    VOUCHER_LIST_FAIL,
  } from "../constants/voucherConstants";
  export const voucherListReducer = (state = { vouchers: {} }, action) => {
  switch (action.type) {
    case VOUCHER_LIST_REQUEST:
      return { loading: true, vouchers: {} };
    case VOUCHER_LIST_SUCCESS:
      return { loading: false, vouchers: action.payload };
    case VOUCHER_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};